export const userHomeSectionGapClassName = 'gap-12 md:gap-16';

export const userHomeCardClassName =
	'relative shrink-0 overflow-hidden rounded-[2.5rem] border border-zinc-200 bg-white p-6 shadow-sm md:p-8';

export const userHomeCardBlurClassName = 'pointer-events-none absolute inset-0';

export const userHomeSectionLabelClassName =
	'text-xs font-semibold uppercase tracking-wider text-zinc-400';

export const userHomePillButtonClassName =
	'group inline-flex items-center gap-1 rounded-full border border-zinc-200 bg-white py-2.5 pl-5 pr-3.5 text-sm font-semibold text-zinc-800 shadow-sm transition-all hover:border-zinc-300 hover:bg-zinc-50 disabled:cursor-not-allowed disabled:opacity-40';

export const userHomePillInputClassName =
	'block w-full rounded-full border border-zinc-200 bg-white px-5 py-2.5 text-sm text-zinc-900 placeholder:text-zinc-400 shadow-sm transition-colors focus:border-zinc-300 focus:outline-none focus:ring-2 focus:ring-zinc-100';

export const userHomePrimaryButtonClassName =
	'inline-flex items-center justify-center rounded-full bg-brand-orange px-8 py-3 text-base font-bold text-white shadow-sm transition-all hover:bg-brand-orange/90';

export const userHomeCardHeaderClassName = 'flex items-start gap-4';

export const userHomeCardIconBoxClassName =
	'flex size-12 shrink-0 items-center justify-center rounded-xl bg-brand-orange/10 text-brand-orange';

export const userHomeDividerClassName = 'border-t border-zinc-100 pt-5';

export const userHomeActionsWrapClassName = 'flex flex-wrap gap-2.5';

export const userHomeDescriptionLinkClassName =
	'group inline-flex items-center gap-0.5 font-medium text-zinc-500 underline-offset-2 transition-colors hover:text-zinc-700 hover:underline';

export const userHomeDescriptionAccentLinkClassName =
	'group inline-flex items-center gap-0.5 font-medium text-brand-orange underline-offset-2 transition-colors hover:text-brand-orange/80 hover:underline';
